import React, { useEffect, useState } from 'react'
import logo from "../assets/logo/logo.jpg"
import { Link } from 'react-router-dom'
import certificate from "../assets/images/certificate.png"
import learning from "../assets/images/learn.png"
import trainer from "../assets/images/trainer.png"
import student from "../assets/images/student.png"
import certifi from "../assets/images/certi.png"
import { Faq, MakingMindsLearningFooter } from '../route'
const MakingMindsLearning = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    useEffect(() => {
        scrollToTop();
    }, []);
    return (
        <div>
            <nav className="bg-mwhite  border-gray-200 dark:bg-gray-900">
                <div className="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl p-4">
                    <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
                        <img src={logo} className="h-8 mr-1" alt="logo" />
                        <span className="self-center text-2xl font-bold font-mfont dark:text-white">
                            Making Minds Technologies
                        </span>
                    </Link>
                    <div className="flex items-center space-x-2 rtl:space-x-reverse">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" className="mt-0.5">
                            <rect width="24" height="24" fill="white" />
                            <circle cx="12" cy="12" r="9" stroke="#000000" strokeLinejoin="round" />
                            <path d="M12 3C12 3 8.5 6 8.5 12C8.5 18 12 21 12 21" stroke="#000000" strokeLinejoin="round" />
                            <path d="M12 3C12 3 15.5 6 15.5 12C15.5 18 12 21 12 21" stroke="#000000" strokeLinejoin="round" />
                            <path d="M3 12H21" stroke="#000000" strokeLinejoin="round" />
                            <path d="M19.5 7.5H4.5" stroke="#000000" strokeLinejoin="round" />
                            <g filter="url(#filter0_d_15_556)">
                                <path d="M19.5 16.5H4.5" stroke="#000000" strokeLinejoin="round" />
                            </g>
                            <defs>
                                <filter id="filter0_d_15_556" x="3.5" y="16" width="17" height="3" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                    <feOffset dy="1" />
                                    <feGaussianBlur stdDeviation="0.5" />
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15_556" />
                                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15_556" result="shape" />
                                </filter>
                            </defs>
                        </svg><a className="text-sm  text-mblack font-mfont dark:text-bmblack hover:underline">English</a>
                    </div>
                </div>
            </nav>
            <nav className="bg-mcolor ">
                <div className="max-w-screen-xl px-1 py-1 mx-auto">
                    <div className="flex flex-wrap   justify-between items-center mx-auto max-w-screen-xl p-2">
                        <Link to="/" className="flex items-center space-x-3 rtl:space-x-reverse">
                            {/* <img src={logo} className="h-8 mr-6" alt="logo" /> */}
                            <span className="self-center  text-mwhite text-2xl font-bold font-mfont dark:text-white">
                                Making Minds Technologies - Learning
                            </span>
                        </Link>
                        <div className="hidden items-left sm:flex justify-end">

                            <ul className="flex  flex-row font-medium mt-0 space-x-8 rtl:space-x-reverse text-md">
                                <li>
                                    <a href="#training" className="text-mwhite cursor-pointer font-mfont font-semibold dark:text-white hover:underline" >Trainings</a>
                                </li>
                                <li>
                                    <Link to="/makingminds/products" className="text-mwhite font-mfont font-semibold dark:text-white hover:underline" >Explore Products</Link>
                                </li>
                                <li>
                                    <a href="#certificate" className="text-mwhite font-mfont font-semibold dark:text-white hover:underline">Certifications</a>
                                </li>
                                <li>
                                    <a href="#faq" className="text-mwhite font-mfont font-semibold dark:text-white hover:underline">FAQ</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </nav>

            <section id='training' className="text-mcolor bg-mwhite mt-10" >
                <div className="container px-5  mx-auto">
                    <div className="grid px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-5 lg:grid-cols-12">
                        <div className="lg:m-1 lg:col-span-6">
                            {/* <h1 className=" mb-4 text-xl uppercase
                            font-extrabold text-mcolor font-mfont
                             dark:text-white">Learning & Campus</h1> */}
                            <div className='flex flex-1'>
                                <h1 className=" mb-4 lg:text-4xl text-3xl 
                            font-extrabold text-mcolor font-mfont
                             dark:text-white">Get <span className='font-mfont uppercase text-myellow'>Certified</span>&nbsp;and&nbsp;
                                    <span className='font-mfont text-myellow uppercase'>Skilled</span></h1>
                            </div>

                            <p className="max-w-3xl mb-6 text-mcolor 
                            lg:mb-8 font-semibold font-mfont md:text-lg lg:text-xl dark:text-gray-400">
                                With the Making Minds Technologies training and certification platform,
                                you may enroll in specific courses that will improve your
                                understanding of Making Minds Technologies products and teach you best
                                practices for our whole app library. Using badges and awards,
                                you may stand out from the competitors.
                            </p>
                            <p className="max-w-3xl mb-6 text-mcolor 
                            lg:mb-8 font-semibold font-mfont md:text-lg lg:text-xl dark:text-gray-400">Choose a product,
                                and we'll help you get started.</p>
                            <Link to="/makingminds/products" className="inline-flex text-center uppercase items-center
                            justify-center px-5 py-3 mr-3 text-base
                            font-medium  text-white rounded-sm bg-mcolor hover:bg-mcolor
            focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900">
                                Explore now
                            </Link>
                        </div>
                        <div className=" lg:mt-0 lg:col-span-5 lg:flex">
                            <img src={certificate} alt="certificate" />
                        </div>
                    </div>
                </div>
            </section >

            <div className="bg-mblue py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="max-w-4xl mx-auto text-center">
                        <h2 className="text-3xl font-semibold font-mfont text-mcolor sm:text-4xl">
                            Making Minds Technologies- Learning & Campus
                        </h2>
                    </div>
                </div>
                <div className="mt-10 pb-1">
                    <div className="relative">
                        <div className="absolute inset-0 h-1/2 bg-mblue"></div>
                        <div className="relative max-w-7xl mx-auto  px-4 sm:px-6 lg:px-8">
                            <div className="max-w-4xl mx-auto">
                                <dl className="rounded-lg bg-white shadow-lg m-3 sm:grid sm:grid-cols-3">
                                    <div className="flex flex-col border-b justify-center border-gray-100 p-10 items-center sm:border-0 sm:border-r">
                                        <img src={learning} alt='learning' className='h-20 mb-3 w-20 text-center' />
                                        <dt className="order-2 mt-2 text-xl  font-mfont leading-6 font-semibold text-gray-500">
                                            Online Course
                                        </dt>
                                        <dd className="order-1 text-5xl font-bold font-mfont text-mblack">10+</dd>
                                    </div>
                                    <div className="flex flex-col border-b justify-center border-gray-100 p-10 items-center sm:border-0 sm:border-r">
                                        <img src={student} alt='student' className='h-20 w-20 mb-3 text-center' />
                                        <dt className="order-2 mt-2 text-xl  font-mfont leading-6 font-semibold text-gray-500">
                                            Happy Students
                                        </dt>
                                        <dd className="order-1 text-5xl font-bold font-mfont text-mblack">20+</dd>
                                    </div>
                                    <div className="flex flex-col border-b justify-center border-gray-100 p-10 items-center sm:border-0 sm:border-r">
                                        <img src={trainer} alt='trainer' className='h-20 w-20 mb-3 text-center' />
                                        <dt className="order-2 mt-2 text-xl  font-mfont leading-6 font-semibold text-gray-500">
                                            Experience Trainers
                                        </dt>
                                        <dd className="order-1 text-5xl font-bold font-mfont text-mblack">3+</dd>
                                    </div>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section className="bg-mwhite dark:bg-gray-900 m-5 lg:m-10" id='certificate'>
                <div className="grid max-w-screen-xl px-4 py-8 mx-auto lg:gap-8 xl:gap-0 lg:py-16 lg:grid-cols-12">
                    <div className="mr-auto place-self-center lg:col-span-7">
                        <h2 className=" mb-4 lg:text-4xl text-3xl
                        font-extrabold text-mcolor font-mfont
                             dark:text-white">
                            Advantages of Certification and Training.
                        </h2>

                        <p className="mt-10 mb-6 text-mcolor 
                            lg:mb-8 font-semibold font-mfont md:text-lg lg:text-xl dark:text-gray-400">
                            Certification and training programs provide individuals with the opportunity
                            to enhance their knowledge and acquire new skills in a specific area.
                            This can help to improve job performance and make individuals more proficient
                            in their field.
                        </p>
                        <Link to="/makingminds/certification" className="inline-flex text-center uppercase items-center
                            justify-center px-5 py-3 mr-3 text-base
                            font-medium  text-white rounded-sm bg-mcolor hover:bg-mcolor
            focus:ring-4 focus:ring-primary-300 dark:focus:ring-primary-900">
                            Explore more
                        </Link>
                    </div>
                    <div className=" lg:mt-0 lg:col-span-5 lg:flex">
                        <img src={certifi} alt="certificate" />
                    </div>
                </div>
            </section >

            <div id='faq'>
                <Faq />
            </div>

            <MakingMindsLearningFooter />
        </div >
    )
}

export default MakingMindsLearning

